module.exports = __webpack_public_path__ + "static/img/banner-年节慰问@2x.5aae60e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner-年节慰问@2x.png
// module id = DaR1
// module chunks = 1